import api from "@/router/api";

export default {
  async postExterno(dadosExterno) {
    const response = await api.post("/externos", dadosExterno);
    return response.data || response;
  },

  async getExternoById(externoId) {
    const response = await api.get(`/externos/${externoId}`);
    return response.data;
  },

  async getExternoByUsuarioId(usuarioId) {
    const response = await api.get(`/externos/usuario/${usuarioId}`);
    return response.data;
  },

  async putExterno(externoId, dadosExterno) {
    const response = await api.put(`/externos/${externoId}`, dadosExterno);
    return response.data;
  },
};
